<script setup>
const props = defineProps(['stats'])

let ratingPercents = Math.round(props.stats.google_rating * 20)
</script>

<template>
  <div class="google-rating-block">
    <div class="google-icon">
      <img :src="versionAsset('/assets/subscription/img/google-icon.svg')" alt="Google rating" />
    </div>
    <div class="info-block">
      <div class="rating-title">{{ $t('layout.labels.subscription.google_rating.google_rating') }}</div>
      <div class="rating-block">
        <div>{{ props.stats.google_rating.toFixed(1) }}</div>
        <div class="rating-stars">
          <div class="unfilled-stars">
            <img :src="versionAsset('/assets/subscription/img/google-rating-star.svg')" alt="Google rating star" />
            <img :src="versionAsset('/assets/subscription/img/google-rating-star.svg')" alt="Google rating star" />
            <img :src="versionAsset('/assets/subscription/img/google-rating-star.svg')" alt="Google rating star" />
            <img :src="versionAsset('/assets/subscription/img/google-rating-star.svg')" alt="Google rating star" />
            <img :src="versionAsset('/assets/subscription/img/google-rating-star.svg')" alt="Google rating star" />
          </div>
          <div class="filled-stars" :style="'width: ' + ratingPercents + 'px'">
            <img :src="versionAsset('/assets/subscription/img/google-rating-star-filled.svg')" alt="Google rating star" />
            <img :src="versionAsset('/assets/subscription/img/google-rating-star-filled.svg')" alt="Google rating star" />
            <img :src="versionAsset('/assets/subscription/img/google-rating-star-filled.svg')" alt="Google rating star" />
            <img :src="versionAsset('/assets/subscription/img/google-rating-star-filled.svg')" alt="Google rating star" />
            <img :src="versionAsset('/assets/subscription/img/google-rating-star-filled.svg')" alt="Google rating star" />
          </div>
        </div>
      </div>
      <div class="reviews">
        <a
          :href="props.stats.google_reviews_link"
          v-html="$t('layout.labels.subscription.google_rating.see_x_reviews', { count: props.stats.google_reviews_count })"
          target="_blank"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.google-rating-block {
  margin-top: 2rem;
  display: flex;
  align-items: center;
}
.google-icon {
  height: 3rem;
  width: 3rem;
  margin-right: 0.5rem;
}
.info-block {
  display: flex;
  flex-direction: column;
}
.rating-block {
  font-size: 1.2rem;
  color: #fea500;
  display: flex;
  align-items: center;
}
.rating-title {
  color: #6a6a6a;
  font-weight: 500;
}
.rating-stars {
  position: relative;
  margin-top: -16px;
  margin-left: 4px;
}
.unfilled-stars {
  width: 100px;
  display: flex;
  position: absolute;
  z-index: 10;
}
.unfilled-stars img {
  height: 16px;
  width: 20px;
}
.filled-stars {
  display: flex;
  position: absolute;
  overflow-x: hidden;
  top: -1px;
  z-index: 20;
}
.filled-stars img {
  height: 20px;
  width: 20px;
}
.reviews {
  color: #868686;
  text-decoration: underline;
  font-size: 0.8rem;
}
.reviews:hover {
  color: #a8a8a8;
}
</style>
